<template>
  <div class="all addDate">
    <div class="warp mt20" style="padding-bottom:20px;">
      <div class="warp-header d-flex justify-between">
        <h2>用户管理</h2>
        <div class="addData curp" @click="addData(null)">新增用户</div>
      </div>
      <div class="warp-body clearfix minheight">
        <table class="table" width="100%" border="0" cellpadding="0" cellspacing="0">
          <colgroup>
            <col width="14%">
            <col width="14%">
            <col width="20%">
            <col width="14%">
            <col width="12%">
            <col width="12%">
            <col width="14%">
          </colgroup>
          <thead>
            <tr>
              <th>用户名</th>
              <th>手机号</th>
              <th>昵称</th>
              <!-- <th>方案数</th> -->
              <th>素材包数</th>
              <th>密码</th>
              <th>状态</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in dataList" :key="index">
              <td>{{ item.username }}</td>
              <td>{{ item.tel }}</td>
              <td>{{ item.nickname }}</td>
              <!-- <td>{{item.schemeNum}}</td> -->
              <td>{{ item.materialPackageNum }}</td>
              <td>{{ item.originalPassword }}</td>
              <td>
                <div class="table-all-icons">
                  <span v-if="item.status == '0'" class="status2">禁止</span>
                  <span v-else-if="item.status == '1'" class="status1">正常</span>
                </div>
              </td>
              <td>
                <div class="table-all-icons">
                  <span class="cp mr8 color-blue" @click="addData(item)">编辑</span>
                  <span class="cp mr8 color-red" @click="delateUser(item.id)">删除</span>
                  <span class="cp mr8 color-orange" @click="openRoot(item.id)">权限</span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- 分页 -->
      <page class="mt20" v-if="totalCount != ''" :currentPage.sync="page" :limit.sync="limit" :totalCount="totalCount"
        @turn="getTableData"></page>
    </div>
    <!-- 新增用户 -->
    <Dialog ref="addDataModal" type="normal" width="550" :title="title" :callback="sureAdd">
      <div slot="mdBox">
        <div class="d-flex">
          <div class="title__ ar"><span class="color-red">*</span>用户名：</div>
          <el-input v-model="username" class="flx1" placeholder="用户名请输入3-15位且只支持字母和数字"></el-input>
        </div>
        <div class="d-flex mt20">
          <div class="title__ ar"><span class="color-red">*</span>手机号：</div>
          <el-input v-model="tel" class="flx1" maxlength="20" placeholder="请输入手机号"></el-input>
        </div>
        <div class="d-flex mt20">
          <div class="title__ ar"><span class="color-red">*</span>昵称：</div>
          <el-input v-model="nickname" class="flx1" placeholder="请输入昵称"></el-input>
        </div>
        <!-- <div class="d-flex mt20">
                    <div class="title__ ar"><span class="color-red">*</span>方案数量：</div>
                    <el-input v-model="schemeNum" class="flx1" type="number" min="0"></el-input>
                </div> -->
        <div class="d-flex mt20">
          <div class="title__ ar"><span class="color-red">*</span>素材包数量：</div>
          <el-input v-model="materialPackageNum" class="flx1" type="number" min="0"></el-input>
        </div>
        <div class="d-flex mt20">
          <div class="title__ ar"><span class="color-red">*</span>密码：</div>
          <el-input v-model="password" class="flx1" type="password" placeholder="长度8-16  不能为纯数字或纯字母"></el-input>
        </div>
        <div class="d-flex mt20">
          <div class="title__ ar">状态：</div>
          <div class="fr mt10">
            <span class="switch" :class="status ? 'active' : ''" @click="oneButtonSwitch();"><i
                class="icons switch-icon"></i></span>
            <span v-if="!status">禁用</span><span v-else>正常</span>
          </div>
        </div>
      </div>
    </Dialog>
    <!-- 权限 -->
    <Dialog ref="rootModal" type="normal" width="600" title="分配方案" :callback="sureRoot">
      <div slot="mdBox">
        <div class="item clearfix" v-if="schemeList && schemeList.length > 0">
          <div v-for="item in schemeList" :key="item.typeId" class="form-item mt20">
            <div class="d-flex" style="align-items: center;">
              <qbCheckbox v-model="item.allsid" :label="item.typeId" @change="qbCheckboxCallbackAll(item)" />
              <div class="form-name ml10 cp" @click="item.show = !item.show">{{ item.typeName }}</div>
              <i class="iconfont icons arrow-top cp" />
            </div>
            <div v-if="item.show" class="form-cont mt10">
              <div class="checkbox-group checkbox-block">
                <qbCheckbox v-for="(it, index) in item.schemeList" :key="it.id" v-model="item.sid"
                  style="margin-right: 26px" :checkbox-length="true" :label="it.id" :text="it.name" :value="it.id"
                  @change="qbCheckboxCallback(item)" />
              </div>
            </div>
          </div>
          <!-- <div class="input-father checkbox-group">
                        <label class="checkbox-box" style="width: 125px;" v-for="(item,index) in schemeList" :key="index">
                            <label class="checkbox-warp fl" :class="schem.indexOf(item.name)  != -1? 'curr' : ''"><input name="" v-model="schem" type="checkbox" :value="item.name" class="checkbox"> <i class="icons checkbox-icon"></i></label>
                            <div class="hidden ac textover" :title="item.name">{{item.name}}</div>
                        </label>
                    </div> -->
        </div>
      </div>
    </Dialog>
    <Dialog ref="delateModal" type="normal" width="400" title="提示" :callback="sureDelate">
      <div slot="mdBox">
        <div>确认删除此用户吗？</div>
      </div>
    </Dialog>
  </div>
</template>
<script>
import Dialog from '../../components/dialog.vue';
import page from '../../components/page.vue';
import qbCheckbox from '@/components/checkbox.vue'
export default {
  components: { Dialog, page, qbCheckbox },
  data() {
    return {
      title: '新增用户',
      dataList: [
        {
          status: 0,
          source_url: '',
          addtime: ''
        }
      ],
      url: '',
      id: '',
      status: false,
      username: '',
      tel: '',
      nickname: '',
      password: '',
      // schemeNum:1,
      materialPackageNum: 1,
      schem: [],
      custom: [],
      schemeList: [],
      page: 1,//页码
      limit: 20,//每页显示条数
      totalCount: '',//总页数
    }
  },
  watch: {
    schem: {
      handler(nval, oval) {
        console.log(nval);
      }
    },
    custom: {
      handler(nval, oval) {
        console.log(nval)
      }
    },
    schemeList: {
      handler(nval, oval) {
        for (let item of nval) {
          if (item.checked == 1) {
            this.schem.push(item.name);
          }
        }
      }
    }
  },
  mounted() {
    this.getdataList();
  },
  created() {

  },
  methods: {
    qbCheckboxCallbackAll(item) {
      if (item.allsid.length != 0) {
        const sid = []
        item.schemeList.forEach(it => {
          sid.push(it.id)
        })
        item.sid = sid
      } else {
        item.sid = []
      }
    },
    // 预警多选
    qbCheckboxCallback(item) {
      if (item.sid.length == item.schemeList.length) {
        item.allsid = [item.typeId]
      } else {
        item.allsid = []
      }
    },
    //删除用户
    delateUser(id) {
      this.id = id;
      this.$refs.delateModal.showMaskFun();
    },
    //确认删除
    sureDelate() {
      let ids = [], that = this;
      ids.push(this.id);
      let parms = {
        ids: ids
      }
      that.$parent.loadModal(true, '正在删除。。。');
      that.$api.post('user/user/del', parms, r => {
        that.$utils.returnCode(r, function () {
          that.$utils.alertText('删除成功');
          that.$refs.delateModal.closeMask();
          that.getdataList();
        })
        that.$parent.showLoad = false;
      })
    },
    //
    addData(item) {
      if (item) {
        this.title = '编辑用户'
        this.username = item.username;
        this.nickname = item.nickname;
        this.status = item.status == 1 ? true : false;
        this.tel = item.tel;
        this.id = item.id;
        // this.schemeNum = item.schemeNum;
        this.materialPackageNum = item.materialPackageNum;
        this.password = item.originalPassword;
      } else {
        this.title = '新增用户';
        this.username = '';
        this.nickname = '';
        this.status = true;
        this.tel = '';
        this.id = '';
        // this.schemeNum = 1;
        this.materialPackageNum = 1;
        this.password = '';
      }
      this.$refs.addDataModal.showMaskFun();
    },
    // 获取
    getdataList() {
      let that = this;
      let parms = {
        page: this.page,
        perpage: this.limit
      }
      that.$api.get('user/user/list', parms, r => {
        that.$utils.returnCode(r, function () {
          that.dataList = r.data.list;
          that.totalCount = Number(r.data.count);
        })
      })
    },
    getTableData() {
      this.getdataList();
    },
    //确认添加
    sureAdd() {
      let that = this;
      if (this.username.length == 0) {
        that.$utils.alertText('请填写用户名');
        return false;
      }
      if (this.nickname.length == 0) {
        that.$utils.alertText('请填写昵称');
        return false;
      }
      if (this.tel.length == 0) {
        that.$utils.alertText('请填写手机号');
        return false;
      }
      if (this.password.length == 0) {
        that.$utils.alertText('请填写密码');
        return false;
      }
      // 判断字符串是否为数字和字母组合
      let zg = /^[0-9a-zA-Z]*$/;
      let sz = /^[0-9]*$/;
      let zm = /^[a-zA-Z]+$/;
      // if (!zg.test(this.password))  {
      //     this.$utils.alertText('密码必须为数字和字母组合');
      //     return false;
      // }else
      if (sz.test(this.password)) {
        this.$utils.alertText('密码不能为纯数字');
        return false;
      } else if (zm.test(this.password)) {
        this.$utils.alertText('密码不能为纯字母');
        return false;
      }

      let parms = {
        id: this.id,
        username: this.username,
        nickname: this.nickname,
        tel: this.tel,
        // schemeNum:this.schemeNum,
        materialPackageNum: this.materialPackageNum,
        password: this.password,
        status: this.status ? 1 : 0
      }
      that.$parent.loadModal(true, '正在保存中。。。');
      that.$api.post('user/user/save', parms, r => {
        if (r.code === 10000) {
          that.$utils.returnCode(r, function () {
            that.$utils.alertText('保存成功');
            that.$refs.addDataModal.closeMask();
            that.getdataList();
            that.$parent.showLoad = false;
          }, function () {
            that.$parent.showLoad = false;
          })
        } else {
          this.$utils.alertText(r.msg);
          that.$parent.showLoad = false;
        }
        // console.log("wwwwwwwwwwwwww");
        //     return


      })
    },
    oneButtonSwitch() {
      this.status = !this.status;
    },
    //修改权限
    openRoot(id) {
      this.id = id;
      this.schem = [];
      this.custom = [];
      this.$refs.rootModal.showMaskFun();
      let that = this;
      //权限列表
      that.$api.get('user/user/user-authority', { id: id }, r => {
        that.$utils.returnCode(r, function () {
          const list = r.data.schemeList
          if (list && list.length > 0) {
            const planList = list.filter(it => it.schemeList && it.schemeList.length != 0)
            planList.forEach((it, index) => {
              it.show = true
              it.sid = []
              it.allsid = []
              it.schemeList.forEach(itId => {
                if (itId.checked == 1) {
                  it.sid.push(itId.id)
                  if (it.sid.length == it.schemeList.length) {
                    it.allsid = [it.typeId]
                  }
                }
              })
            })
            that.schemeList = planList
            // this.showAround = true
          } else this.$utils.alertText('请先添加方案')
        })
      })
    },
    //确认修改
    sureRoot() {
      const saveSchemeList = []
      this.schemeList.forEach(item => {
        item.schemeList.forEach(it => {
          if (item.sid.indexOf(it.id) != -1) {
            it.checked = 1
          } else {
            it.checked = -1
          }
          saveSchemeList.push(it)
        })
      })
      let that = this;
      let parms = {
        id: this.id,
        schemeList: saveSchemeList
      }
      that.$parent.loadModal(true, '正在保存中。。。');
      that.$api.post('user/user/save-user-authority', parms, r => {
        that.$utils.returnCode(r, function () {
          that.$utils.alertText('保存成功');
          that.schem = [];
          that.custom = [];
          that.$refs.addDataModal.closeMask();
          that.$refs.rootModal.closeMask();

        })
        that.$parent.showLoad = false;
      })
    }
  }
}
</script>
<style scope>
.title__ {
  width: 100px !important;
}

.textover {
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/page/personalCenter/userManage.vue